import Vue from 'vue'
import VAdImg1  from './adImg1'

export default VAdImg1




// WEBPACK FOOTER //
// ./src/components/index/mobile/adImg1/index.js